import { render, staticRenderFns } from "./groupNotice.vue?vue&type=template&id=5f050a4a&scoped=true&"
import script from "./groupNotice.vue?vue&type=script&lang=js&"
export * from "./groupNotice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f050a4a",
  null
  
)

export default component.exports